import styled from 'styled-components'

export const SensitiveSpeciesPageContainer = styled.div`
  padding-top: 32px;
  padding-left: 56px;
  padding-right: 56px;
  padding-bottom: 32px;
`

export const SensitiveSpeciesPageTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 40px;
  color: #202020;
  margin-bottom: 24px;
`

export const SensitiveSpeciesTableWrapper = styled.div`
  margin: 0;

  td:nth-child(1) {
    min-width: 120px;
    max-width: 120px;
  }

  td:nth-child(2) {
    min-width: 250px;
  }

  td:nth-child(3) {
    min-width: 200px;
  }

  td:nth-child(4) {
    min-width: 200px;
  }

  td:nth-child(5) {
    min-width: 100px;
    max-width: 100px;
  }
`

export const SensitiveSpeciesFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 32px 0;
`

export const SensitiveSpeciesStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SensitiveSpeciesStatusDot = styled.span`
  width: 8px;
  height: 8px;
  min-width: 8px;
  min-height: 8px;
  border-radius: 50%;
  background-color: ${(p) => p.color || 'rgba(255, 193, 7, 1)'};
  flex-shrink: 0;
`

export const SensitiveSpeciesStatusText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #1a365d;
`

export const SensitiveSpeciesStatusBadge = styled.div`
  width: auto;
  min-width: 80px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${(p) => p.color || 'rgba(255, 153, 0, 1)'};
  color: ${(p) => {
    // Light text for dark backgrounds, dark text for light backgrounds
    const darkColors = ['rgba(225, 25, 0, 1)', 'rgba(5, 148, 79, 1)']
    return darkColors.includes(p.color) ? '#FFFFFF' : '#202020'
  }};
`

export const FileLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FileLinkItem = styled.div`
  display: flex;
  align-items: center;
`

export const FileLinkItemText = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0AA1F4;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
    color: #0885c2;
  }
  
  &:visited {
    color: #0AA1F4;
  }
`

export const FileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`

export const ReviewModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ReviewModalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ReviewModalSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #202020;
  margin: 0 0 8px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`

export const ReviewModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ReviewModalFieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #202020;
  margin-bottom: 4px;
`

export const ReviewModalFieldValue = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #202020;
  padding: 10px 14px;
  background: rgba(250, 250, 250, 1);
  border-radius: 4px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  min-height: 40px;
  display: flex;
  align-items: center;
`

export const ReviewModalFilesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ReviewModalFileItem = styled.li`
  padding: 12px 16px;
  background: rgba(250, 250, 250, 1);
  border-radius: 4px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(245, 245, 245, 1);
    border-color: rgba(32, 32, 32, 0.15);
  }
`

export const ReviewModalFileLink = styled.a`
  display: flex;
  width: 100%;
  color: #0AA1F4;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  
  &:hover {
    text-decoration: underline;
    color: #0885c2;
  }
`

export const ReviewModalFileLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const ReviewModalFileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  
  svg {
    width: 16px;
    height: 16px;
    path {
      fill: #0AA1F4;
    }
  }
`

export const ReviewModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 24px;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
`

export const ReviewModalStatusSelect = styled.select`
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 12px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  border-radius: 4px;
  background: #ffffff;
  color: #202020;
  cursor: pointer;
  min-height: 40px;
  
  &:focus {
    outline: none;
    border-color: #0AA1F4;
  }
  
  &:disabled {
    background: rgba(250, 250, 250, 1);
    cursor: not-allowed;
  }
`

export const ReviewModalStatusOption = styled.option`
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 12px;
`

